import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IEntitlementRepository } from '../../repositories/interfaces/iEntitlementRepository';
import { IEntitlementPurchaseResponse, TVODPurchaseRequest } from '../../../entity/interface/iEntitlements';
export interface ITvodPurchaseUseCase {
    execute(
        username: string,
        payload: TVODPurchaseRequest,
        token: string,
        identityToken: string
    ): Promise<IEntitlementPurchaseResponse>;
}

export class TvodPurchaseUseCase implements ITvodPurchaseUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get tvodPuchaseRepository(): IEntitlementRepository {
        return container.resolve<IEntitlementRepository>(DI.REPOSITORIES.IEntitlementRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }
    async execute(
        username: string,
        payload: TVODPurchaseRequest,
        token: string,
        identityToken: string
    ): Promise<IEntitlementPurchaseResponse> {
        return this.tvodPuchaseRepository.tVodPurchase(username, payload, token, identityToken);
    }
}
